<template>
  <div class="product">
    <v-app id="product">
      <v-content v-if="item">
        <div class="container">
          <div class="columns">
            <div class="column is-4">
              <router-link to="/">Home</router-link>
              <v-icon>mdi-forward</v-icon>
              <router-link :to="'/products/'+ item.Cat_slug">
                {{ item.Cat_slug | capitalize}}
              </router-link>
              <v-icon>mdi-forward</v-icon>
              {{  item.name | capitalize }}
              <v-hover v-slot:default="{ hover }">
                <v-card class="mx-auto" color="grey lighten-4" max-width="600">
                  <v-img :src="getImage(item.productImages)" >
                    <v-expand-transition>
                      <div v-if="hover" class="d-flex transition-fast-in-fast-out indigo darken-2 v-card--reveal display-1 white--text" style="height: 100%;" @click="index = 0">
                         click for more...
                      </div>
                    </v-expand-transition>
                  </v-img>
                </v-card>
              </v-hover> 
              <vue-gallery-slideshow :images="item.productImages" :index="index" @close="index = null"></vue-gallery-slideshow>
            </div>
            <div class="column is-5">
              <div>
                <h1 class="title is-4">
                  {{ item.name | capitalize }}
                </h1>
                <span class="label">Category: {{ item.Cat_slug | uppercase}}</span>
                <span class="label">Client: {{ item.client | capitalize}}</span>
                <span class="label">Town: {{ item.town_code | capitalize}}</span>
                <span class="label">Layby Price: 50 with Tooltip showing instructions</span>
                <p>
                  <span class="label">Availabilty: ({{ item.quantity }}) InStock</span>
                </p>
                <v-layout align-center v-if="ratingo.length == 0">
                  <span class="label">Ratings:</span>
                  <div class="grey--text ml-4">
                    <b>Be The First To Rate This Product</b>
                  </div>
                </v-layout>
                <v-layout v-else>
                  <span class="label">Ratings:</span>
                  <v-rating 
                    :value="ratingSum()/ratingo.length" color="amber" 
                    half-increments dense 
                    size="20" readonly>
                  </v-rating>
                  <div class="grey--text ml-4">
                    {{ratingSum()/ratingo.length | number('0.00')}}
                    (<b>{{ ratingo.length }}</b>)
                  </div>
                </v-layout>
                <hr>
                <span 
                  class="tag is-rounded is-medium is-dark" 
                  v-if="item.quantity == 0">
                  Out of stock
                </span>
                <span class="tag is-rounded is-medium">
                  <b v-if="userIsAuthenticated">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <span v-on="on">
                          <v-icon medium color="pink darken-2" @click="addToWishlist">mdi-tag</v-icon>
                        </span>
                      </template>
                      <span>Add To Wishlist</span>
                    </v-tooltip> 
                    {{ item.price | currency('K ') }}
                  </b>
                  <b v-else>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <span v-on="on">
                          <v-icon medium color="grey lighten-1" @click="signin_viewer">mdi-tag</v-icon>
                        </span>
                      </template>
                      <span>Please SignIn First</span>
                    </v-tooltip> 
                    {{ item.price | currency('K ') }}
                  </b>
                </span>
              </div>
              <v-divider></v-divider>
            </div>
            <div class="column is-3">
              <div class="label">Share:</div>
              <social-sharing :url="'https://vergeo-21ffc.firebaseapp.com/product/'+ item.slug" 
                :title="item.name" 
                :description="item.description" 
                :quote="'Please visit this link to view this product by ' + item.client" 
                :hashtags="'Convergeo '+ item.client + item.name" twitter-user="Convergeo" 
                inline-template>
                <div>
                  <network network="facebook">
                    <a href="#"><img src="@/assets/facebook.jpg" alt="Facebook" width="30" /> <v-divider class="mx-4" vertical></v-divider></a>
                  </network>
                  <network network="linkedin">
                    <a href="#"><img src="@/assets/linkedIn.png" alt="linkedin" width="30" /> <v-divider class="mx-2" vertical></v-divider></a>
                  </network> 
                  <network network="pinterest">
                    <a href="#"><img src="@/assets/pinterest.jpg" alt="pinterest" width="30" /> <v-divider class="mx-2" vertical></v-divider></a>
                  </network> 
                  <network network="skype">
                    <a href="#"><img src="@/assets/skype.jpg" alt="skype" width="30" /> <v-divider class="mx-2" vertical></v-divider></a>
                  </network> 
                  <network network="twitter">
                    <a href="#"><img src="@/assets/twitter.jpg" alt="Twitter" width="30" /> <v-divider class="mx-2" vertical></v-divider></a>
                  </network> 
                  <network network="whatsapp">
                    <a href="#"><img src="@/assets/whatsapp.jpg" alt="whatsapp" width="30" /> <v-divider class="mx-2" vertical></v-divider></a>
                  </network>
                </div>
              </social-sharing>
              <span class="label"><b>{{ commento.length }}</b> Reviews <v-icon> mdi-comment-text-multiple-outline </v-icon></span>
              <span class="label"><b>Quantity:</b></span>
              <div>
                <div class="field has-addons">
                  <v-icon left color="red" @click="subtractQuantity">mdi-minus</v-icon>
                  <v-chip
                    class="ma-2"
                    color="black"
                    outlined
                  >
                    {{quantityNumber}}
                  </v-chip>
                  <v-icon left color="green" @click="addQuantity">mdi-plus</v-icon>
                </div>
                <div class="control" v-if="userIsAuthenticated">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span v-on="on">
                        <v-btn color="black" dark small rounded @click="addToProductCart"><v-icon small>mdi-cart</v-icon>
                        </v-btn>
                      </span>
                    </template>
                    <span>Add To Cart</span>
                  </v-tooltip>
                </div>
                <div class="control" v-else>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span v-on="on">
                        <v-btn color="grey" dark small rounded @click="signin_viewer"><v-icon small>mdi-cart</v-icon>
                        </v-btn>
                      </span>
                    </template>
                    <span>Please SignIn First</span>
                  </v-tooltip>
                </div>
              </div>
            </div>
          </div>
        </div>
        <v-tabs dark background-color="indigo lighten-4" show-arrows>
          <v-tabs-slider color="black"></v-tabs-slider>
          <v-tab><b class="label">Description</b></v-tab>
          <v-tab><b class="label">Specification</b></v-tab>
          <v-tab><b class="label">Reviews({{ commento.length }})</b></v-tab>
          <v-tab><b class="label">Related Products</b></v-tab>
          <v-tab-item>
            <span style="min-height: 600px;">
              <v-textarea v-html="item.description"></v-textarea>
            </span>
          </v-tab-item>
          <v-tab-item>
            <span style="min-height: 600px;">
              <v-simple-table fixed-header>
                <tbody>
                  <tr v-for="specific in specifico" :key="specific.id">
                    <td><i class="label">{{specific.name}}</i></td>
                    <td><b class="label">{{specific.value_spec}}</b></td>
                  </tr>
                </tbody>
              </v-simple-table>
            </span>
          </v-tab-item>
          <v-tab-item>
            <span style="min-height: 600px;">
              <div class="columns">
                <div class="column is-9">
                  <template>
                    <v-timeline :reverse="reverse" dense>
                      <v-timeline-item
                        v-for="comment in commento"
                        :key="comment.id"
                      >
                        <template v-slot:icon>
                          <v-avatar v-if="comment.user_image">
                            <img :src="comment.user_image">
                          </v-avatar>
                          <v-avatar v-else>
                            <!-- <img src="http://i.pravatar.cc/64"> -->
                            <b style="color: white">
                              {{comment.user_name[0] | uppercase}}
                            </b>
                          </v-avatar>
                        </template>
                        <v-card class="elevation-2">
                          <v-card-text>
                            <v-card-title class="subtitle-1 font-weight-black">
                              {{comment.user_name}}
                            </v-card-title>
                            {{comment.product_comment}}
                          </v-card-text>
                          <p style="text-align: right;" class="overline">
                            <b v-if="fb.auth().currentUser.uid">
                              <v-icon
                                v-if="comment.user == fb.auth().currentUser.uid"
                                small
                                color="purple lighten-2"
                                @click="deleteReview(comment)"
                              >
                                mdi-delete
                              </v-icon>
                              <timeago 
                                :datetime="comment.time"
                                :refresh="360"></timeago>
                            </b>
                          </p>
                        </v-card>
                      </v-timeline-item>
                    </v-timeline>
                  </template>
                </div>
                <div class="column is-3" v-if="userIsAuthenticated">
                  <v-dialog v-model="dialog" max-width="500px">
                    <template v-slot:activator="{ on }">
                      <v-btn color="indigo" rounded small dark  v-on="on" @click="addNew">
                        <v-icon>
                          mdi-comment-text-multiple-outline mdi-24px
                        </v-icon>
                      </v-btn>
                    </template>    
                    <v-card style="border-radius: 15px;">
                      <v-container>
                        <v-system-bar style="background-color: white;">
                          <v-spacer></v-spacer>
                          <v-subheader><a><b @click="close">X</b></a></v-subheader>
                        </v-system-bar>
                        <b class="label">Review This Product Here.</b>
                        <b>Rate This Product<v-rating v-model="ratings.product_rating" color="yellow darken-3" background-color="grey darken-1" half-increments empty-icon="$vuetify.icons.ratingFull" hover required></v-rating></b>
                        <v-textarea append-outer-icon="mdi-message-reply-text" label="Your Review" outlined v-model="comments.product_comment" counter="100" auto-grow class="mx-2"></v-textarea>
                        <a @click="switcher"><v-btn color="indigo" class="mr-4" rounded small dark @click="addProductComments" v-if="(comments.product_comment !== '') && (ratings.product_rating === '')">
                        Add Review</v-btn></a>
                        <a @click="switcher"><v-btn color="indigo" class="mr-4" rounded small dark v-if="ratings.product_rating !== '' && (comments.product_comment === '')" @click="addProductRating">
                        Add Review</v-btn></a>
                        <b @click="switcher"><a @click="addProductComments" v-if="(ratings.product_rating !== '') && (comments.product_comment !== '')"><v-btn color="indigo" class="mr-4" rounded small dark @click="addProductRating">
                        Add Review</v-btn></a></b>
                      </v-container>
                    </v-card>
                  </v-dialog><br><br>
                  <v-btn 
                    color="purple lighten-2" dark rounded
                    small @click="view_review">
                    View All
                  </v-btn>
                </div>
                <div class="column is-3" v-else>
                  <v-btn 
                    color="grey" rounded 
                    small dark @click="signin_viewer">
                    SignIn To Review
                  </v-btn>
                  <br><br>
                  <v-btn 
                    color="purple lighten-2" dark rounded
                    small @click="view_review">
                    View All
                  </v-btn>
                </div>
              </div>
            </span>
          </v-tab-item>
          <v-tab-item>
            <span style="min-height: 600px;">
              <v-item-group>
                <v-container>
                  <v-row>
                    <v-col v-for="n in 3" :key="n"
                      cols="12" md="4">
                      <v-item v-slot:default="{ active, toggle }">
                        <v-card
                          :color="active ? 'primary' : ''"
                          class="d-flex align-center"
                          dark
                          height="200"
                          @click="toggle"
                        >
                          <v-scroll-y-transition>
                            <div
                              v-if="active"
                              class="display-3 flex-grow-1 text-center"
                            >
                              Active
                            </div>
                          </v-scroll-y-transition>
                        </v-card>
                      </v-item>
                    </v-col>
                  </v-row>
                </v-container>
              </v-item-group>
            </span>
          </v-tab-item>
        </v-tabs>
      </v-content>
      <generalfab />
    </v-app>
  </div>
</template>

<script>
  import Vue from 'vue'
  import {fb, db, auth} from '@/firebase'
  import SocialSharing from 'vue-social-sharing'
  Vue.use(SocialSharing)
  import VueGallerySlideshow from 'vue-gallery-slideshow'

  export default {
    data: () => ({
      item: null,
      userauth: null,
      reverse: true,
      product_comments: [],
      comments: {
        product_id: '',
        product_slug: '',
        product_comment: '',
        user_id: '',
        client_id: '',
        user_name: ''
      },
      commento: [],
      specifico: [],
      ratingo: [],
      ratings: {
        product_id: '',
        product_slug: '',
        product_rating: '',
        user_id: ''
      },
      quantityNumber: 1,
      quantityValue: null,
      index: null,
      dialog: false
    }),

    created(){
      auth.onAuthStateChanged(userauth => {
        if(userauth){
          this.userauth = userauth;
        } else {
          this.userauth = null;
        }
      })

      //get item data 
      let ref = db.collection('products')
      .where('slug', '==', this.$route.params.slug)
      ref.get().then(snapshot => {
        snapshot.forEach(doc => {
            this.item = doc.data()
            this.item.id = doc.id
        })
      })

      db.collection('product_specifications')
      .where('pimg_slug','==',this.$route.params.slug).get()
      .then(snapshot =>{
        snapshot.forEach(doc =>{
          let specific = doc.data()
          specific.id =  doc.id
          this.specifico.push(specific)
        })
      })

      db.collection('product_comments')
      .limit(5)
      .where('product_slug','==',this.$route.params.slug).get()
      .then(snapshot =>{
        snapshot.forEach(doc =>{
          let comment = doc.data()
          comment.id =  doc.id
          this.commento.push(comment) 
        })
      })

      db.collection('ratings')
      .where('product_slug','==',this.$route.params.slug).get()
      .then(snapshot =>{
        snapshot.forEach(doc =>{
          let rating = doc.data()
          rating.id =  doc.id
          this.ratingo.push(rating) 
        })
      })

      //get current user
      db.collection('user')
      .where('user_id','==',fb.auth().currentUser.uid).get()
      .then(snapshot=>{
        snapshot.forEach(doc => {
          this.user =doc.data(),
          this.user.id = doc.id//
        })
      })
    },

    watch: {
      dialog (val) {
        val || this.close()
      }
    },

    firestore: {
      product_comments: db.collection('product_comments')
    },

    methods: {
      getImage(productImages){
        return productImages[0]
      },
      signin_viewer(){
        this.$router.push({ 
          name: 'signin_alt', 
          params: { slug: this.item.slug }
        })
      },
      deleteReview(comment){
        /* eslint-disable */
        Swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            this.$firestoreRefs.product_comments.doc(comment.id).delete()
            .then(() => {
              this.switcher()              
            })                        
          }
        })
        /* eslint-enable */
      },
      view_review(){
        this.$router.push({ 
          name: 'reviews', 
          params: { slug: this.item.slug }
        })
      },
      addNew(){
        this.reset()
        this.dialog = true
      },
      switcher(){
        this.$router.push({ 
          name: 'product', 
          params: { slug: this.item.slug }
        })
      },
      ratingSum(){
        return this.ratingo.reduce((prev,cur) => prev + cur.product_rating,0)
      },
      reset(){
        this.ratings = {
          product_id: '',
          product_slug: '',
          product_rating: '',
          user_id: ''
        }
        this.comments = {
          product_id: '',
          product_slug: '',
          product_comment: '',
          client_slug: '',
          user_name: '',
          user_id: ''
        }  
      },
      addQuantity(){
        if (this.quantityNumber>=0 && this.quantityNumber<= this.item.quantity-2){
            this.quantityNumber++
        }
      },
      subtractQuantity(){
          if (this.quantityNumber>0){
              this.quantityNumber--
          }
      },
      addToProductCart(){
        this.quantityValue = this.quantityNumber
        this.total = ((this.quantityValue)*(this.item.price))
        // db.collection('products').doc(this.item.id).update({
        //     quantity: ((this.item.quantity)-(this.quantityValue))
        // })
        // USE THIS IN THE CHECKOUT INSTEAD
        db.collection('cartitems').add({
            product_name: this.item.name,
            product_image: this.item.productImages,
            product_price: this.item.price,
            client_name: this.item.client,
            client_town: this.item.town_code,
            product_quantity: this.quantityValue,
            product_total: this.total,
            product_id: this.item.id,
            user: fb.auth().currentUser.uid
        }).then(() => {
        /* eslint-disable */
        Toast.fire({
          type: 'success',
          title: 'product added to cart'
        })
        }).catch(err => {
            console.log(err);
        })
        /* eslint-enable */
      },
      addToWishlist(){
        db.collection('wishlists').add({
          product_name: this.item.name,
          product_slug: this.item.slug,
          product_image: this.item.productImages,
          client_name: this.item.client,
          client_town: this.item.town_code,
          product_id: this.item.id,
          user: fb.auth().currentUser.uid
        }).then(() => {
        /* eslint-disable */
        Toast.fire({
          type: 'success',
          title: 'product added to wishlist'
        })
        }).catch(err => {
            console.log(err);
        })
        /* eslint-enable */
      },
      addProductComments(){
        db.collection('product_comments').add({
          product_id: this.item.id,
          product_slug: this.item.slug,
          client_slug: this.item.client,
          user_name: this.user.name,
          product_comment: this.comments.product_comment,
          user: fb.auth().currentUser.uid,
          user_image: this.user.user_image
        }).then(() => {
        /* eslint-disable */
          Toast.fire({
            type: 'success',
            title: 'Review Successful!'
          })
          this.close()
        }).catch(err => {
          console.log(err);
        })
        /* eslint-enable */
      },
      addProductRating(){
        db.collection('ratings').add({
          product_id: this.item.id,
          product_slug: this.item.slug,
          product_rating: this.ratings.product_rating,
          user: fb.auth().currentUser.uid
        }).then(() => {
        /* eslint-disable */
          Toast.fire({
            type: 'success',
            title: 'Review Successful!'
          })
          this.close()
        }).catch(err => {
          /* eslint-disable */
          console.log(err);
          /* eslint-enable */
        }) 
      },
      updateProductRating(){
        db.collection('ratings').doc(this.item.id).update({
          quantity: ((this.item.quantity)-(this.quantityValue))
        })
      },
      close () {
        this.dialog = false
      }
    },

    computed: {
      userIsAuthenticated () {
        return this.userauth != null && this.userauth != undefined
      }
    },

    components: {
      VueGallerySlideshow
    }
  }
</script>

<style scoped>
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: .5;
  position: absolute;
  width: 100%;
}
</style>

